<template>
    <div class="user_view__reporError">
        <h1 class="user_view__reporError--text">LO SENTIMOS TENEMOS ERROR EN LA CONEXION</h1>
        <button 
            @click="handleReload" 
            class="user_view__reporError__button">
            Volver a cargar
        </button>
    </div>
</template>
<script>
export default {
    methods: {
        handleReload(){
            location.reload()
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/shared/ReportsError.vue